wbApp.factory('attendanceSvc', ['$resource', '$q' , 'repositorySvc', 
    function ($resource, $q, repositorySvc) {

        var Attendance = $resource('/Api/Attendnce/Get', {}, {
            'getLessonAttendance': { method: 'GET', isArray: true, url: '/Api/Attendance/GetLessonAttendance' },
            'getStudentCourseAttendance': { method: 'GET', isArray: true, url: '/Api/Attendance/GetStudentCourseAttendance' },
            'getAllForCourseAndUser': { method: 'GET', isArray: true, url: '/Api/Attendance/GetAllForCourseAndUser' },
            'getAllForCourse': { method: 'GET', isArray: true, url: '/Api/Attendance/GetAllForCourse' },
            'getAttendanceSummary': { method: 'GET', isArray: true, url: '/Api/Attendance/GetAttendanceSummary' },
            'getStudentAttendanceDetail': { method: 'GET', isArray: true, url: '/Api/Attendance/GetStudentAttendanceDetail' },
            'update': { method: 'POST', url: '/Api/Attendance/Update' },
            'insert': { method: 'POST', url: '/Api/Attendance/Insert' },
            'delete': { method: 'POST', url: '/Api/Attendance/Delete' },
        });

        function insert(data, collection, successCallback, errorCallback) {
            repositorySvc.insert(
                Attendance,               // $resource
                collection,               // collection
                data,                     // entity
                successCallback,
                errorCallback);
        }

        function update(data, collection, successCallback, errorCallback) {
            repositorySvc.update(
                Attendance,            // $resource
                collection,            // collection
                data,                  // entity
                successCallback,
                errorCallback);
        }

        function getLessonAttendance(courseScheduleID) {
            return repositorySvc.customGet('getLessonAttendance', Attendance, {
                courseScheduleID: courseScheduleID
            });
        }

        function getStudentCourseAttendance(courseID, studentID) {
            return repositorySvc.customGet('getStudentCourseAttendance', Attendance, {
                courseID: courseID,
                studentID: studentID
            });
        }

        function remove(data, collection, successCallback, errorCallback) {
            repositorySvc.customPost(
                'delete',
                Attendance,        // $resource
                data,              // entity
                successCallback,   // successCallback
                errorCallback);
        }


        var lastCourseID;
        var lastUserID;
        var lastAttendanceByUser;
        
        var lastRefreshedAt = null; 

        function getStudentCourseAttendanceByUser(courseID, studentID, userID, refresh) {
            var deferred = $q.defer();
            var result = [];
            result.$promise = deferred.promise;
            
            let refreshDebounce = refresh && (moment().isSameOrAfter(moment(lastRefreshedAt).add(500, 'ms')));
            if (lastCourseID != courseID || lastUserID != userID || !lastAttendanceByUser || refreshDebounce) {

                lastRefreshedAt = moment();
                
                lastCourseID = courseID;
                lastUserID = userID;
                lastAttendanceByUser = repositorySvc.customGet('getAllForCourseAndUser', Attendance, {
                    courseID: courseID,
                    userID: userID
                });
            }
            
            lastAttendanceByUser.$promise.then(function (data) {
                var filtered = _.filter(data, { studentID: studentID });
                result.push.apply(result, filtered);
                deferred.resolve(result);
            });

            return result;
        }

        function getAllForCourse(courseID) {
            return repositorySvc.customGet('getAllForCourse', Attendance, {
                courseID: courseID
            });
        }

        function getAttendanceSummary(studentID) {
            return repositorySvc.customGet('getAttendanceSummary', Attendance, {
                studentID: studentID
            });
        }

        function getStudentAttendanceDetail(studentID) {
            return repositorySvc.customGet('getStudentAttendanceDetail', Attendance, {
                studentID: studentID
            });
        }

        // courseScheduleDTO: {
        //   "courseScheduleID": 493286,
        //   "startDate": "2017-02-14T16:00:00",
        //   "teacher": "Petra Brabcová",
        //   "classroomName": "hudební učebna",
        // }
        // studentAttendanceDTO: {
        //   "studentID": 1234,
        //   "courseScheduleID": "",
        //   "fullName": "Nikola Brabcova",
        //   "attendanceStatus": 0,
        //   "attendanceType": 0,
        //   "modified": false,
        //   "attendanceCount": 1
        // }
        // result: [ 
        //   {
        //     "studentID": 1234,
        //     "fullName": "Nikola Brabcova",
        //     "493286": {   // courseScheduleID
        //         "startDate": "2017-02-14T16:00:00",
        //         "attendanceStatus": 0,
        //         "attendanceType": 0,
        //         "modified": false,
        //         "attendanceCount": 1
        //     },
        //     "493287": {   // courseScheduleID
        //     }
        //   }, {
        //      ...
        //   }
        // ]
        function prepareFullCourseAttendanceTable(studentAttendanceDTOs, courseScheduleDTOs) {
            var attendanceByStudent = _.groupBy(studentAttendanceDTOs, 'studentID');
            var result = [];
            var mnow = moment();

            _.forIn(attendanceByStudent, function (value, key) {
                var firstAttendance = _.head(value);
                var attendanceMapBySchedule = _.keyBy(value, 'courseScheduleID');
                var student = {
                    studentID: Number(key),
                    fullName: firstAttendance.fullName,
                    isRegistered: !!_.find(value, { attendanceType: 0 })
                };
                result.push(student);

                _.forEach(courseScheduleDTOs, function (schedule) {
                    var attendance = attendanceMapBySchedule[schedule.courseScheduleID];
                    if (attendance && moment(schedule.startDate).isAfter(mnow) && !attendance.attendanceStatus) {
                        attendance = null;
                    }

                    if (!!attendance) {
                        student[schedule.courseScheduleID] = {
                            startDate: schedule.startDate,
                            attendanceStatus: attendance.attendanceStatus,
                            attendanceType: attendance.attendanceType,
                            modified: attendance.modified,
                            attendanceCount: attendance.attendanceCount,
                        };
                    } else {
                        student[schedule.courseScheduleID] = {
                            startDate: schedule.startDate,
                            attendanceStatus: null,
                            attendanceType: null,
                            modified: null,
                            attendanceCount: null,
                        };
                    };
                });
            });

            return result;
        }

        function groupAttendanceDetail(attendanceDetail) {

            var deferred = $q.defer();
            var result = [];
            result.$promise = deferred.promise;

            attendanceDetail.$promise.then(function (data) {
                var grouping = _.groupBy(data, 'impliedCourseID');
                var rr = [];
                _.forEach(grouping, function (items) {
                    rr.push({
                        course: 'Kurz: ' + items[0].impliedCourse,
                        courseID: items[0].impliedCourseID,
                        isGroupRow: true,
                        items: _.sortBy(items, function (o) {
                            return o.startDate;
                        })
                    });
                });
                result.push.apply(result, _.sortBy(rr, function (o) {
                    return o.courseID;
                }));
                deferred.resolve(result);
            });

            return result;
        }

        return {
            insert: insert,
            update: update,
            remove: remove,
            getLessonAttendance: getLessonAttendance,
            getStudentCourseAttendance: getStudentCourseAttendance,
            getStudentCourseAttendanceByUser: getStudentCourseAttendanceByUser,
            getAttendanceSummary: getAttendanceSummary,
            getStudentAttendanceDetail: getStudentAttendanceDetail,
            groupAttendanceDetail: groupAttendanceDetail,
            getAllForCourse: getAllForCourse,
            prepareFullCourseAttendanceTable: prepareFullCourseAttendanceTable
        }
    }
]);
